import React, { useMemo } from "react";
import { ChalkboardEvent, SUBTYPE } from "../utils";
import { getBorderColorForEvent } from "../helper";

type Props = {
  events: ChalkboardEvent[];
  status: any;
};

const isShotSubtype = (sub: number) =>
  sub === SUBTYPE.Goals ||
  sub === SUBTYPE.ShotOnTargets ||
  sub === SUBTYPE.ShotOffTargets ||
  sub === SUBTYPE.BlockedShots;

export const ShotPaths: React.FC<Props> = ({ events }) => {
  const shots = useMemo(
    () =>
      events.filter((e) => e.category === "Shots" && isShotSubtype(e.subtype)),
    [events]
  );

  if (!shots.length) return null;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      style={{ position: "absolute", inset: 0, pointerEvents: "none" }}
    >
      {shots.map((e) => {
        const x1 = (e.x ?? 0) * 100;
        const y1 = (e.y ?? 0) * 100;
        const x2 = (e.tx ?? e.x ?? 0) * 100;
        const y2 = (e.ty ?? e.y ?? 0) * 100;

        const borderColorClass = getBorderColorForEvent(e);

        return (
          <React.Fragment key={`shot-line-${e.id}`}>
            <defs>
              <marker
                id={`arrowhead-${e.id}`}
                markerWidth="4"
                markerHeight="4"
                refX="2.8"
                refY="2"
                orient="auto"
                markerUnits="strokeWidth"
              >
                <path
                  d="M0,0 L0,4 L4,2 Z"
                  className={borderColorClass}
                  fill="currentColor"
                />
              </marker>
            </defs>
            <line
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              className={borderColorClass}
              stroke="currentColor"
              strokeWidth="0.5vw"
              vectorEffect="non-scaling-stroke"
              markerEnd={`url(#arrowhead-${e.id})`}
            />
          </React.Fragment>
        );
      })}
    </svg>
  );
};
